import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_REST_URL,
  withCredentials: false,
  header: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

export default {
  addToBasket(basketRequest) {
    return apiClient.put('/basket', basketRequest);
  },
  clearCache() {
    return apiClient.get('/cache');
  },
  createAnonymousSession() {
    return apiClient.put('/session');
  },
  setAuthHeader(session) {
    if (session == null) {
      apiClient.defaults.headers.common['Authorization'] = null;
      localStorage.removeItem('session');
    } else {
      apiClient.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${session.id}`;
      localStorage.setItem('session', JSON.stringify(session));
    }
  },
  setErrorHandler(errorHandler, store) {
    apiClient.interceptors.response.use(
      response => response, // return the response
      error => {
        errorHandler(error, store);
      }
    );
  },
  login(email, password) {
    return apiClient.put('/session', {
      email: email,
      password: password
    });
  },
  register(firstName, lastName, email, password) {
    return apiClient.put('/user', {
      firstName: firstName,
      lastName: lastName,
      email: email,
      password: password
    });
  },
  logout() {
    return apiClient.delete('/session/');
  },
  getBasket() {
    return apiClient.get('/basket');
  },
  getPackage(packageId) {
    return apiClient.get('/packages/' + packageId);
  },
  getGenres() {
    return apiClient.get('/genres');
  },
  getShows(showFilter, page, pageSize) {
    if (showFilter != null) {
      return apiClient.get(
        '/shows' +
          '?genreId=' +
          showFilter.genreId +
          '&page=' +
          page +
          '&pageSize= ' +
          pageSize +
          '&searchText=' +
          showFilter.searchText
      );
    } else {
      return apiClient.get('/shows');
    }
  },
  getShow(showId) {
    if (showId != null) {
      return apiClient.get('/shows/' + showId);
    }
  },
  getPerformances(id) {
    if (id != null) {
      return apiClient.get('/performances?showId=' + id);
    }
  },
  getPerformance(performanceId) {
    if (performanceId != null) {
      return apiClient.get('/performances/' + performanceId);
    }
  },
  getPerformanceProducts(id) {
    if (id != null) {
      return apiClient.get('/products?performanceId=' + id);
    }
  },
  getShowProducts(id) {
    if (id != null) {
      return apiClient.get('/products?showId=' + id);
    }
  },
  getPrices(productId) {
    if (productId != null) {
      return apiClient.get('/prices?productId=' + productId);
    }
  },
  getSeatPlan(productId) {
    if (productId != null) {
      return apiClient.get('/seatplan?productId=' + productId);
    }
  },
  getQuantities(productId) {
    if (productId != null) {
      return apiClient.get('/quantities?productId=' + productId);
    }
  }
};
